import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { RootState } from 'modules';
import { TLearningParams } from 'modules/learning/boardTypes';
import { CFINANCE_THEME, CMAIN_THEMES } from 'constants/learningboard.const';
import { ERoute } from 'enums/route.enum';
import { Button } from 'antd';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

type TWidth = {
  primaryField: string | undefined;
};

const RecommendSubjectList = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const { category }: TLearningParams = useParams();

  const recommendList =
    currentUser?.primary_field !== 'finance'
      ? CMAIN_THEMES.filter(({ link }) => link !== category)
      : CFINANCE_THEME.filter(({ link }) => link !== category);

  return (
    <StyledRecomendSubject>
      <StyledHeader>다른 주제 더 알아보기</StyledHeader>
      <StyledBtnList primaryField={currentUser?.primary_field}>
        {recommendList.map(({ link, name, id }) => (
          <>
            <Link to={`${ERoute.CSLearningBoard}/${link}/view`} key={id}>
              <Button className='secondary'>{name}</Button>
            </Link>
            <StyledDivider primaryField={currentUser?.primary_field} />
          </>
        ))}
      </StyledBtnList>
    </StyledRecomendSubject>
  );
};

export default RecommendSubjectList;

const StyledRecomendSubject = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
`;

const StyledHeader = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #747474;
`;

const StyledBtnList = styled.div<TWidth>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: ${({ primaryField }) => (primaryField === 'finance' ? '700px' : '800px')};
  margin: 13px auto 64px auto;

  @media screen and ${device.md} {
    width: 70%;
  }

  .secondary {
    margin: 6px 8px;
    padding: 3px 10px;
    height: 26px;
  }
`;

const StyledDivider = styled.div<TWidth>`
  width: 1px;
  height: 14px;
  border: 1px solid #aeaeae;

  @media screen and ${device.md} {
    display: none;
  }

  &:nth-child(10) {
    display: ${({ primaryField }) => (primaryField === 'finance' ? 'none' : 'block')};
  }

  &:nth-child(8) {
    display: none;
  }

  &:nth-child(12) {
    display: none;
  }
`;
